var map = {
	"./": 319,
	"./LiveStream.module.scss": 344,
	"./LiveStreamDeferred": 1147,
	"./LiveStreamDeferred.tsx": 1147,
	"./actions": 76,
	"./actions.ts": 76,
	"./components/MatchesDropdown": 300,
	"./components/MatchesDropdown/": 300,
	"./components/MatchesDropdown/MatchesDropdown.dictionary": 372,
	"./components/MatchesDropdown/MatchesDropdown.dictionary.json": 372,
	"./components/MatchesDropdown/MatchesDropdown.module.scss": 456,
	"./components/MatchesDropdown/index": 300,
	"./components/MatchesDropdown/index.tsx": 300,
	"./components/Players": 977,
	"./components/Players/": 977,
	"./components/Players/HLSHandler": 1041,
	"./components/Players/HLSHandler.tsx": 1041,
	"./components/Players/Twitch/TwitchHandler": 1042,
	"./components/Players/Twitch/TwitchHandler.module.scss": 1110,
	"./components/Players/Twitch/TwitchHandler.tsx": 1042,
	"./components/Players/Twitch/global.d": 1148,
	"./components/Players/Twitch/global.d.ts": 1148,
	"./components/Players/YouTubeHandler": 1043,
	"./components/Players/YouTubeHandler.tsx": 1043,
	"./components/Players/index": 977,
	"./components/Players/index.ts": 977,
	"./components/ToolbarButtons": 302,
	"./components/ToolbarButtons/": 302,
	"./components/ToolbarButtons/ToolbarButtons.dictionary": 373,
	"./components/ToolbarButtons/ToolbarButtons.dictionary.json": 373,
	"./components/ToolbarButtons/index": 302,
	"./components/ToolbarButtons/index.tsx": 302,
	"./components/ToolbarControls": 301,
	"./components/ToolbarControls/": 301,
	"./components/ToolbarControls/ToolbarControls.dictionary": 374,
	"./components/ToolbarControls/ToolbarControls.dictionary.json": 374,
	"./components/ToolbarControls/index": 301,
	"./components/ToolbarControls/index.tsx": 301,
	"./constants": 320,
	"./constants.ts": 320,
	"./index": 319,
	"./index.tsx": 319,
	"./local-storage-helpers": 252,
	"./local-storage-helpers.ts": 252,
	"./records": 220,
	"./records.ts": 220,
	"./reducer": 294,
	"./reducer/": 294,
	"./reducer/entries": 351,
	"./reducer/entries.ts": 351,
	"./reducer/index": 294,
	"./reducer/index.ts": 294,
	"./saga": 361,
	"./saga.ts": 361,
	"./selectors": 97,
	"./selectors.ts": 97,
	"./types": 1023,
	"./types/": 1023,
	"./types/backend/liveStream": 1149,
	"./types/backend/liveStream.ts": 1149,
	"./types/index": 1023,
	"./types/index.ts": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1280;
module.exports = webpackContext;